import { Icon } from '@ui/themed';
import { t } from 'i18next';
import { useHandlers, useSite } from '../../../context/page-context';
import { trackUpgradeClicked } from '../../../lib/mixpanel';
import { PARTNERS_I18N } from '../constants';

const PAGE = PARTNERS_I18N.page;

export function PartnerUpsell({ partnerName }: { partnerName: string }) {
  const site = useSite();
  const { navigationHandler } = useHandlers();

  return (
    <div className="hidden pl-6 text-right lg:block">
      <div className="-mb-0.5 flex items-center text-gray-500 text-xs">
        {t(`${PAGE}.upsell.available_on`)}
      </div>
      <button
        type="button"
        className="inline-flex cursor-pointer items-center font-medium text-indigo-600 text-xs hover:text-indigo-500"
        onClick={() => {
          trackUpgradeClicked(site, partnerName);
          navigationHandler.navigateById('plan');
        }}
      >
        <span>{t(`${PAGE}.upsell.change_plan`)}</span>
        <Icon name="externalLink" size="sm" />
      </button>
    </div>
  );
}
